var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.infoLoading,
          expression: "infoLoading",
        },
      ],
      staticClass: "org-infor",
    },
    [
      _c(
        "div",
        { staticClass: "org-logo" },
        [
          _c("el-avatar", {
            attrs: { size: 91.6, src: _vm.orgDetailData.logoUrl },
          }),
        ],
        1
      ),
      _c("h3", { staticClass: "name-cn" }, [
        _vm._v(_vm._s(_vm.orgDetailData.nameCn || _vm.orgDetailData.nameEn)),
      ]),
      _c("p", { staticClass: "org-location" }, [
        _vm._v(" " + _vm._s(_vm.orgDetailData.country) + " "),
        _vm.orgDetailData.city ? _c("span", [_vm._v("|")]) : _vm._e(),
        _vm._v(" " + _vm._s(_vm.orgDetailData.city) + " "),
        _vm.orgDetailData.district ? _c("span", [_vm._v("|")]) : _vm._e(),
        _vm._v(" " + _vm._s(_vm.orgDetailData.district) + " "),
      ]),
      _vm.orgType === "company"
        ? _c(
            "p",
            { staticClass: "innovation-index" },
            [
              _vm._v(" 企业创新指数 "),
              _c(
                "el-tooltip",
                {
                  staticClass: "item",
                  attrs: {
                    effect: "light",
                    "popper-class": "definition-class",
                    content: _vm.definitionItem,
                    placement: "top",
                  },
                },
                [
                  _c("img", {
                    staticStyle: { width: "14px", height: "14px" },
                    attrs: {
                      src: require("@/assets/images/org/icon-question.png"),
                      alt: "",
                    },
                    on: {
                      mouseenter: function ($event) {
                        return _vm.handleGetDefinition("企业创新指数")
                      },
                    },
                  }),
                ]
              ),
              _vm._v("  "),
              _c("span", [
                _vm._v(_vm._s(_vm.orgDetailData.innovationIndex || 0)),
              ]),
            ],
            1
          )
        : _c("p", { staticClass: "innovation-index" }, [
            _vm._v(" 科研创新指数 "),
            _c("span", [
              _vm._v(_vm._s(_vm.orgDetailData.innovationIndex || 0)),
            ]),
          ]),
      _vm.orgType === "company"
        ? _c(
            "div",
            { staticClass: "tag-view flex flex-wrap" },
            _vm._l(_vm.orgDetailData.tag, function (title, idx) {
              return _c("span", { key: idx }, [_vm._v(_vm._s(title))])
            }),
            0
          )
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "filed-list",
          attrs: { title: _vm.orgDetailData.fieldListStr },
        },
        [
          _c("span", [_vm._v("主要技术领域：")]),
          _vm._v(" " + _vm._s(_vm.orgDetailData.fieldListStr || "-") + " "),
        ]
      ),
      _c("div", { staticClass: "interest-list" }, [
        _c("span", [_vm._v("主要研究方向：")]),
        _vm._v(" " + _vm._s(_vm.orgDetailData.interestListStr || "-") + " "),
      ]),
      _c("div", { staticClass: "desc" }, [
        _c("span", [_vm._v("简介：")]),
        _vm._v(" " + _vm._s(_vm.orgDetailData.description || "-") + " "),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }